import styled from 'styled-components';
import Box from './Box';

import {
	space,
	color,
	fontSize,
	width,
	flexWrap,
	flexDirection,
	alignItems,
	justifyContent
} from 'styled-system';

const Flex = styled(Box).attrs({})`
    ${flexWrap}
	${flexDirection}
	${alignItems}
	${justifyContent}
	${space}
	${color}
	${fontSize}
	${width}
    position: relative;
    display: ${props => (props.grid ? 'grid' : 'flex')};

	@media screen and (max-width: 530px) {
		grid-template-columns: 1fr;
		flex-wrap: wrap;
	}
`;

Flex.propTypes = {
	...space.PropTypes,
	...color.PropTypes,
	...fontSize.PropTypes,
	...width.PropTypes,
	...flexWrap.PropTypes,
	...flexDirection.PropTypes,
	...alignItems.PropTypes,
	...justifyContent.PropTypes
};

export default Flex;
